import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TheLabAlphaHero from "./sections/TheLabAlphaHero";
import TheNeonVault from "./sections/TheNeonVault";
import AuthenticityAndPrivacyStandards from "./sections/AuthenticityAndPrivacyStandards";
import VoicesOfTheElite from "./sections/VoicesOfTheElite";
import ReadyForTransformation from "./sections/ReadyForTransformation";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TheLabAlphaHero />
      <TheNeonVault />
      <AuthenticityAndPrivacyStandards />
      <VoicesOfTheElite />
      <ReadyForTransformation />
      <Footer />
    </div>;
}